const BASE = "/api/aichat";

async function jsonFetch(url, options = {}) {
  const res = await fetch(url, {
    credentials: "same-origin",
    ...options,
    headers: { "Content-Type": "application/json", ...(options.headers || {}) },
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(data.message || data.error || `HTTP ${res.status}`);
    err.code = data.code;
    err.status = res.status;
    throw err;
  }
  return data;
}

export function listSessions({ status = "ACTIVE", limit = 20, offset = 0, keyword = null } = {}) {
  const qs = new URLSearchParams({ status, limit, offset });
  if (keyword) qs.set("keyword", keyword);
  return jsonFetch(`${BASE}/sessions?${qs}`);
}

export function createSession({ roleCode, title = null }) {
  return jsonFetch(`${BASE}/sessions`, {
    method: "POST",
    body: JSON.stringify({ roleCode, title }),
  });
}

export function getSession(id) {
  return jsonFetch(`${BASE}/sessions/${id}`);
}

export function archiveSession(id) {
  return jsonFetch(`${BASE}/sessions/${id}`, { method: "DELETE" });
}

export function listAdminSessions({ userId = null, limit = 20, offset = 0 } = {}) {
  const qs = new URLSearchParams({ limit, offset });
  if (userId != null) qs.set("userId", String(userId));
  return jsonFetch(`${BASE}/admin/sessions?${qs}`);
}
